import styled from "styled-components";

export const PresetButtonStyled = styled.div`
    text-align: center;
    background: var(--color-neutral-10);
    color: var(--color-white-60);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    padding: 0 12px;
    cursor: pointer;
    font-weight: 600;
    white-space: nowrap;

    svg {
        fill: var(--color-white);
    }

    &.big {
        height: 48px;
        font-size: 18px;
    }

    &.disabled {
        opacity: 0.65;
        cursor: default;
    }
`;
